<div
  class="kr-exchange-details__title"
  translate="exchange.dialog.exchangeDetails"></div>
<div class="kr-exchange-details__row">
  <kr-wallet-card
    data-testid="exchange_crypto_fiat_wallet_from"
    [wallet]="walletFrom" />
  <fu-icon
    class="kr-exchange-details__icon-arrow"
    iconName="arrow-right-filled"
    size="48" />
  <div class="kr-exchange-details__placeholder">
    <fu-icon iconName="badge" size="32" />
  </div>
</div>
<div class="kr-exchange-details__grid">
  <div class="kr-details">
    <label class="kr-details__label" translate="exchange.dialog.amount">
    </label>

    <span
      class="kr-details__value"
      data-testid="exchange_crypto_fiat_total_send"
      >{{
        estimation()?.totalValueToSend.amount.toString()
          | balanceFormat: estimation()?.totalValueToSend.symbol
      }}
      {{ estimation()?.totalValueToSend.symbol }}</span
    >
    <span class="kr-details__hint"
      >({{ 'exchange.dialog.approximate' | translate }})</span
    >
  </div>

  <div class="kr-details">
    <label class="kr-details__label" translate="exchange.dialog.fromWallet">
    </label>

    <span
      class="kr-details__value"
      data-testid="exchange_crypto_fiat_wallet_from">
      {{ walletFrom?.address }}
    </span>
  </div>

  <div class="kr-details">
    <label class="kr-details__label" translate="exchange.dialog.toIBAN">
    </label>

    <span class="kr-details__value" data-testid="exchange_crypto_fiat_iban">{{
      form().value.iban
    }}</span>
  </div>

  <div class="kr-details">
    <label
      class="kr-details__label"
      translate="exchange.dialog.beneficiaryName">
    </label>

    <span
      class="kr-details__value"
      data-testid="exchange_crypto_fiat_beneficiary_name"
      >{{ form().value.beneficiaryName }}</span
    >
  </div>

  <div class="kr-details">
    <label class="kr-details__label" translate="exchange.dialog.bic"> </label>

    <span
      class="kr-details__value"
      data-testid="exchange_crypto_fiat_bic_swift_code"
      >{{ form().value.BICOrSWIFTCode }}</span
    >
  </div>

  <div class="kr-details">
    <label
      class="kr-details__label"
      translate="exchange.dialog.incorporateNumber">
    </label>

    <span
      class="kr-details__value"
      data-testid="exchange_crypto_fiat_icorp_num"
      >{{ form().value.incorporateNum }}</span
    >
  </div>

  <div class="kr-details">
    <label class="kr-details__label" translate="exchange.dialog.reference">
    </label>

    <span class="kr-details__value" data-testid="exchange_crypto_fiat_ref">{{
      form().value.reference
    }}</span>
  </div>

  <!--  <div class="kr-details">-->
  <!--    <label-->
  <!--      class="kr-details__label"-->
  <!--      translate="exchange.dialog.paymentDescription">-->
  <!--    </label>-->

  <!--    <span class="kr-details__value"> Some text </span>-->
  <!--  </div>-->

  <div class="kr-details">
    <label
      class="kr-details__label"
      translate="exchange.dialog.amountToReceive">
    </label>

    <span
      class="kr-details__value"
      data-testid="exchange_crypto_fiat_amount_to_receive">
      {{
        estimation()?.valueToReceive.amount.toString()
          | balanceFormat: estimation()?.valueToReceive.symbol
      }}
      {{ estimation()?.valueToReceive.symbol }}
    </span>
  </div>

  <div class="kr-details">
    <label
      class="kr-details__label"
      translate="exchange.dialog.beneficiaryAddress">
    </label>

    <span
      class="kr-details__value"
      data-testid="exchange_crypto_fiat_benef_address"
      >{{ form().value.beneficiaryAddress }}</span
    >
  </div>

  @if (form().value.transferType === 'swift') {
    <div class="kr-details">
      <label
        class="kr-details__label"
        translate="exchange.dialog.beneficiaryBankName">
      </label>

      <span
        class="kr-details__value"
        data-testid="exchange_crypto_fiat_bank_name"
        >{{ form().value.beneficiaryBankName }}</span
      >
    </div>

    <div class="kr-details">
      <label
        class="kr-details__label"
        translate="exchange.dialog.beneficiaryBankAddress">
      </label>

      <span
        class="kr-details__value"
        data-testid="exchange_crypto_fiat_bank_address"
        >{{ form().value.beneficiaryBankAddress }}</span
      >
    </div>

    <div class="kr-details">
      <label class="kr-details__label" translate="exchange.dialog.bicSwiftCode">
      </label>

      <span
        class="kr-details__value"
        data-testid="exchange_crypto_fiat_corresponding_bic_or_swift"
        >{{ form().value.correspondentBankBICOrSWIFTCode }}</span
      >
    </div>

    <div class="kr-details">
      <label
        class="kr-details__label"
        translate="exchange.dialog.correspondentBankName">
      </label>

      <span
        class="kr-details__value"
        data-testid="exchange_crypto_fiat_corresponding_bank_name"
        >{{ form().value.correspondentBankName }}</span
      >
    </div>

    <div class="kr-details">
      <label
        class="kr-details__label"
        translate="exchange.dialog.correspondentBankAddress">
      </label>

      <span
        class="kr-details__value"
        data-testid="exchange_crypto_fiat_corresponding_bank_address"
        >{{ form().value.correspondentBankAddress }}</span
      >
    </div>
  }
</div>
<div class="kr-exchange-details__row-between kr-margin-top">
  <div class="kr-details">
    <label
      class="kr-details__label kr-margin-bottom"
      translate="exchange.dialog.rate">
    </label>

    <span
      class="kr-details__value"
      data-testid="exchange_crypto_fiat_corresponding_rate"
      [class]="timeLeft() === 0 ? 'kr-details__danger' : null">
      1 {{ walletFrom?.coin.symbol }} = {{ estimation()?.rate.toString() }} EUR
    </span>
  </div>

  <div class="kr-details">
    <div class="kr-exchange-details__row-start">
      <label class="kr-details__label" translate="exchange.dialog.networkFee">
      </label>
      <kr-copy-tooltip
        [text]="'exchange.dialog.estimatedFeeCharge' | translate"
        [copy]="false" />
    </div>

    <span
      class="kr-details__value"
      [class]="timeLeft() === 0 ? 'kr-details__danger' : null"
      data-testid="exchange_crypto_fiat_fee_amount"
      >{{
        estimation()?.operationFee.amount.toString()
          | balanceFormat: estimation()?.operationFee.symbol
      }}
      {{ estimation()?.operationFee.symbol }}</span
    >
  </div>

  <div class="kr-details">
    <div class="kr-exchange-details__row-start">
      <label class="kr-details__label" translate="exchange.dialog.platformFee">
      </label>
      <kr-copy-tooltip
        [text]="'exchange.dialog.estimatedFeeCharge' | translate"
        [copy]="false" />
    </div>

    <span
      class="kr-details__value"
      data-testid="exchange_crypto_fiat_fee"
      [class]="timeLeft() === 0 ? 'kr-details__danger' : null"
      >{{
        estimation()?.operationFee.amount.toString()
          | balanceFormat: estimation()?.operationFee.symbol
      }}
      {{ estimation()?.operationFee.symbol }}</span
    >
  </div>

  <div class="kr-details">
    <label class="kr-details__label" translate="exchange.dialog.expires">
    </label>

    @if (!timeLeft()) {
      <button
        type="button"
        fuButton
        size="s"
        uiType="primary"
        data-testid="exchange_crypto_fiat_reset_timer_btn"
        (click)="resetTimer()"
        translate="Update"></button>
    } @else {
      <span class="kr-details__value">
        {{ 'exchange.dialog.in' | translate }} {{ timeLeft() }}
        {{ 'exchange.dialog.sec' | translate }}
      </span>
    }
  </div>
</div>
<div class="kr-exchange-details__info">
  <fu-icon iconName="information" size="16" />
  {{ 'exchange.dialog.additionalFees' | translate }}
</div>
